import { createWithEqualityFn } from "zustand/traditional";
import { shallow } from "zustand/shallow";
import { persist, createJSONStorage } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";
import idbKeyvalAdapter from "./1_utility";
import devDebug from "../Helpers/debug";

// define the initial state
const initialState = {
  companies: {
    total_pages: 1,
    results: [],
  },
  page: 1,
  pageSize: 10,
  pageInputVisible: false,
  filterColumns: [],
  searchColumns: [],
  orderingTable: { id: "award_count", desc: true },
  orderingURL: "-award_count",
  name: "",
  companiesSearchStatus: "loading",
};
const currentAppVersionFromEnv = Number(import.meta.env.VITE_VERSION);

export const useCompaniesSearchStore = createWithEqualityFn(
  persist(
    immer((set, get) => ({
      ...initialState,
      setCompaniesSearchStatus: (companiesSearchStatus) =>
        set((state) => {
          state.companiesSearchStatus = companiesSearchStatus;
        }),
      setCompanies: (payload) =>
        set((state) => {
          state.companies = payload;
        }),
      columnChange: (columnID) =>
        set((state) => {
          const filterColumns =
            state.filterColumns;
          if (!filterColumns.includes(columnID)) {
            state.filterColumns.push(columnID);
          } else {
            state.filterColumns =
              filterColumns.filter((col) => col !== columnID);
          }
        }),
      setOrdering: (url, table) =>
        set((state) => {
          state.orderingURL = url;
          state.orderingTable = table;
        }),
      setPage: (payload) =>
        set((state) => {
          state.page = payload;
        }),
      setPageSize: (payload) =>
        set((state) => {
          state.pageSize = payload;
        }),
      setPageInputVisible: (payload) =>
        set((state) => {
          state.pageInputVisible = payload;
        }),
      setFilterColumns: (payload) =>
        set((state) => {
          state.filterColumns = payload;
        }),
      setSearchColumns: (payload) =>
        set((state) => {
          state.searchColumns = payload;
        }),
      setName: (payload) =>
        set((state) => {
          state.name = payload;
        }),
      resetState: () => {
        useCompaniesSearchStore.persist.clearStorage();
        set(initialState);
      },
    })),
    {
      name: import.meta.env.VITE_COMPANIES_SEARCH_STORE_KEY,
      storage: createJSONStorage(() => idbKeyvalAdapter),
      version: currentAppVersionFromEnv,
      migrate: (persistedState, storedVersion) => {
        devDebug(
          `[companiesSearchStore Migrate] Called! Stored: ${storedVersion} (type: ${typeof storedVersion}), App: ${currentAppVersionFromEnv} (type: ${typeof currentAppVersionFromEnv})`
        );
        if (storedVersion !== currentAppVersionFromEnv) {
          devDebug('[companiesSearchStore Migrate] Versions differ. Resetting to initialState.');
          return initialState;
        }
        if (persistedState === null || persistedState === undefined) {
          devDebug('[companiesSearchStore Migrate] Persisted state is null/undefined despite version match. Resetting.');
          return initialState;
        }
        devDebug('[companiesSearchStore Migrate] Versions same. Using persisted state.');
        return persistedState;
      },
      // merge: (persistedState, currentState) => {
      //   devDebug('[companiesSearchStore Merge] Merging state...');
      //   if (typeof persistedState !== 'object' || persistedState === null) {
      //     devDebug('[companiesSearchStore Merge] Persisted state is not an object, returning current state or initialState.');
      //     return initialState;
      //   }
      //   return mergeDeepLeft(persistedState, currentState);
      // },
      onRehydrateStorage: (state) => {
        devDebug(`[companiesSearchStore onRehydrateStorage] Attempting rehydration...`);
        return (hydratedState, error) => {
          if (error) {
            console.error(
              `[companiesSearchStore] Failed to rehydrate store!`,
              error
            );
            devDebug(
              `[companiesSearchStore] Error during rehydration. Store name: "companiesSearchStore".`,
              "Error object:", error,
              "State passed to onRehydrateStorage:", state, // This is the raw value from storage before parsing/migration
              "Hydrated state (if available):", hydratedState // This is the state *after* potential migration/parsing, if it got that far
            );
          } else {
            // devDebug(
            //   `[companiesSearchStore] Successfully rehydrated. Hydrated state:`,
            //   hydratedState
            // );
          }
        };
      },
    }
  ),
  shallow
);
